import React from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';

import Settings from './SlickSettings';
import { TrekLists } from './data';

const settings = {
  ...Settings,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const PerfectTreks = () => (
  <div className="horizontal-scroll-content" id="horizontal-scroll-content-1">
    <div className="container mb-1">
      <div className="row">
        <div className="col-12 py-4">
          <h2 className="text-uppercase text-center section-header">
            STEP 2: FIND AND BOOK YOUR DREAM TOUR
          </h2>
          <p className="font-weight-normal text-center">
            Because we specialize, we provide five-star service and flexible booking options at unbeatable prices.
          </p>
          <hr className="hr--small mb-4" />
          <div className="hexagon-perfect-trek-container d-none d-md-block">
            <style dangerouslySetInnerHTML={renderMarkup()} />
            <div className="hexagon-wrapper hexagon-wrapper-0">
              <div className="hexagon hexagon--perfect-trek">
                <div className="hexagon-border" />
              </div>
            </div>

            {TrekLists.map((trek, idx) => (
              <a
                href={trek.url}
                className={`hexagon-wrapper hexagon-wrapper-${idx + 1}`}
                key={trek.name}
              >
                <div
                  className={`hexagon hexagon--perfect-trek hexagon--perfect-trek-${idx +
                    1}`}
                >
                  <div className="hexagon-background">
                    <div className="hexagon-background-content">
                      <div className="text-center px-4">
                        <h6 className="mb-0">{trek.name}</h6>
                        <p className="mb-0">
                          {trek.day && `${trek.day} Days`} {trek.price && `| $ ${trek.price}`}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            ))}
          </div>
          <div className="hexagone-perfect-trek-container perfect-trek-container-mobile  d-md-none">
            <Slider {...settings}>
              {TrekLists.map((trek, idx) => (
                <div
                  className={`hexagon-wrapper hexagon-wrapper-${idx + 1}`}
                  key={trek.name}
                >
                  <div
                    className={`hexagon hexagon--perfect-trek hexagon--perfect-trek-${idx +
                      1}`}
                  >
                    <Link to={trek.url}>
                      <div className="hexagon-background">
                        <div className="hexagon-background-content">
                          <div className="text-center pl-2 pr-2">
                            <h6 className="mb-0">{trek.name}</h6>
                            <p className="mb-0">
                              {trek.day && `${trek.day} Days`} {trek.price && `| $ ${trek.price}`}
                            </p>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const renderMarkup = () => ({
  __html: `
          \n.hexagon--perfect-trek-1 .hexagon-background {
            \n background-image:url(https://s3.amazonaws.com/honeyguide/assets/ebc-trek-2021.jpg);\n
          }\n
          .hexagon--perfect-trek-2 .hexagon-background {
            \n background-image:url(https://s3.amazonaws.com/honeyguide/assets/namche-trek-2020.jpg);\n
          }\n
          .hexagon--perfect-trek-3 .hexagon-background {
            \n  background-image:url(https://s3.amazonaws.com/honeyguide/assets/heli-2020.jpg);\n
            }\n
            .hexagon--perfect-trek-4 .hexagon-background {
              \n background-image:url(https://s3.amazonaws.com/honeyguide/assets/flight-lukla-2020.jpg);\n
            }\n
            .hexagon--perfect-trek-5 .hexagon-background {
              \n background-image:url(https://s3.amazonaws.com/honeyguide/assets/hotels-in-everest.jpg);\n
            }\n
            .hexagon--perfect-trek-6 .hexagon-background {
              \n background-image:url(https://s3.amazonaws.com/honeyguide/assets/guides-at-lukla.jpg);\n
            }\n
            .hexagon--perfect-trek-8 .hexagon-background {
              \n background-image:url(https://s3.amazonaws.com/honeyguide/assets/ebc-gokyo.jpg);\n
            }\n
          .hexagon--perfect-trek-7 .hexagon-background {
                \nbackground-image:url(https://s3.amazonaws.com/honeyguide/assets/3-pass.jpg);\n
              }\n
          .hexagon--perfect-trek-9 .hexagon-background {
                \n background-image:url(https://s3.amazonaws.com/honeyguide/assets/plus.jpg);\n
              }\n
          `,
});

export default PerfectTreks;



// WEBPACK FOOTER //
// ./src/screens/Landing/PerfectTrek.jsx